import {
    ADD_MEMBER_TO_SMS,
    DELETE_MEMBER_TO_SMS,
    EMPTY_MEMBER_TO_SMS,
} from './mutations-type'

var _ = require('underscore');

// initial state
const state = {
    membersToSMS: [],
}


// mutations
const mutations = {
    [ADD_MEMBER_TO_SMS](state, message) {
        state.membersToSMS.push(message);
        state.membersToSMS=_.uniq(state.membersToSMS, 'id');
    },
    [EMPTY_MEMBER_TO_SMS](state, message) {
        state.membersToSMS=[];
    },
    [DELETE_MEMBER_TO_SMS](state, message) {
        state.membersToSMS = _.reject(state.membersToSMS, function (item) {
            return item.id == message;
        });
        state.membersToSMS=_.uniq(state.membersToSMS, 'id');
    },
}

const actions = {
    /*
    {
        id: item.id,
        club: item.club,
        gsm: item.gsm,
        nom: item.nom,
        prenom: item.prenom
    }
     */
    addMemberToSMS({commit}, msg) {
        commit(ADD_MEMBER_TO_SMS, msg)
    },
    deleteMemberFromSMS({commit}, msg) {
        commit(DELETE_MEMBER_TO_SMS, msg)
    },
    emptyMemberToSMS({commit}, msg) {
        commit(EMPTY_MEMBER_TO_SMS, msg)
    },

}

const getters = {
    getMemberToSMS: state => {
        return state.membersToSMS;
    },

}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/vuex/store-sms.js